import { render, staticRenderFns } from "./HideLongText.vue?vue&type=template&id=b4a7a10a&scoped=true&"
import script from "./HideLongText.vue?vue&type=script&lang=js&"
export * from "./HideLongText.vue?vue&type=script&lang=js&"
import style0 from "./HideLongText.vue?vue&type=style&index=0&id=b4a7a10a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a7a10a",
  null
  
)

export default component.exports